<template>
  <BaseCard>
    <BaseCardBody>
      <div class="space-y-4">
        <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4">
          <div class="sm:pt-2">
            <BaseFormLabel for="billing_interval">Billing interval</BaseFormLabel>
          </div>
          <div class="sm:col-span-2 flex gap-2 items-center">
            <div class="flex gap-2 items-center">
              <BaseFormSelectFieldWithValidator
                v-model="billingIntervalInput"
                v-bind="billingIntervalFieldProps"
                :disabled="disabled"
              />
              <BaseFormSelectFieldWithValidator
                v-model="billingPeriodInput"
                v-bind="billingPeriodFieldProps"
                :disabled="disabled"
              />
            </div>
            <ul v-if="billingIntervalErrors.length" class="space-y-1 mt-2">
              <li v-for="(msg, msgIdx) in billingIntervalErrors" :key="msgIdx">
                <BaseFormInlineMessage danger>
                  {{ msg }}
                </BaseFormInlineMessage>
              </li>
            </ul>
          </div>
        </div>
        <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4">
          <div class="sm:pt-2">
            <BaseFormLabel for="billing_length">Billing length</BaseFormLabel>
          </div>
          <div class="sm:col-span-2">
            <BaseFormSelectFieldWithValidator
              v-model="billingLengthInput"
              v-bind="billingLengthFieldProps"
              :disabled="disabled"
            />
            <ul v-if="billingLengthErrors.length" class="space-y-1 mt-2">
              <li v-for="(msg, msgIdx) in billingLengthErrors" :key="msgIdx">
                <BaseFormInlineMessage danger>
                  {{ msg }}
                </BaseFormInlineMessage>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import { pick } from 'lodash-es';

export default {
  props: {
    billingPeriod: {
      type: String,
      default: 'month',
    },
    billingInterval: {
      type: Number,
      default: 1,
    },
    billingLength: {
      type: Number,
      default: null,
    },
    disabled: Boolean,
  },
  computed: {
    billingPeriodInput: {
      get() {
        return this.billingPeriod;
      },
      set(billingPeriod) {
        this.$emit('update:billing-period-value', billingPeriod);
      },
    },
    billingIntervalInput: {
      get() {
        return this.billingInterval;
      },
      set(billingInterval) {
        this.$emit('update:billing-interval-value', billingInterval);
      },
    },
    billingLengthInput: {
      get() {
        return this.billingLength;
      },
      set(billingLength) {
        this.$emit('update:billing-length-value', billingLength);
      },
    },
    billingPeriodFieldProps() {
      return {
        validator: {
          name: 'billing period',
          vid: 'billing_period',
          rules: { required: true },
        },
        field: {
          id: 'billing_period',
          options: [
            { label: 'month', value: 'month' },
            { label: 'year', value: 'year' },
          ],
          required: true,
        },
        withoutInlineErrorMessage: true,
      };
    },
    billingIntervalFieldProps() {
      return {
        validator: {
          name: 'billing interval',
          vid: 'billing_interval',
          rules: { required: true },
        },
        field: {
          id: 'billing_interval',
          options: [
            { label: 'every', value: 1 },
            { label: 'every 2nd', value: 2 },
            { label: 'every 3rd', value: 3 },
            { label: 'every 4th', value: 4 },
            { label: 'every 5th', value: 5 },
            { label: 'every 6th', value: 6 },
          ],
          required: true,
        },
        withoutInlineErrorMessage: true,
      };
    },
    billingLengthFieldProps() {
      return {
        validator: {
          name: 'billing length',
          vid: 'billing_length',
          rules: { required: false },
        },
        field: {
          id: 'billing_length',
          options: [
            { label: 'Never expire', value: null },
            { label: `3 ${this.billingPeriod}s`, value: 3 },
            { label: `6 ${this.billingPeriod}s`, value: 6 },
            { label: `9 ${this.billingPeriod}s`, value: 9 },
            { label: `12 ${this.billingPeriod}s`, value: 12 },
            { label: `15 ${this.billingPeriod}s`, value: 15 },
            { label: `18 ${this.billingPeriod}s`, value: 18 },
            { label: `21 ${this.billingPeriod}s`, value: 21 },
            { label: `24 ${this.billingPeriod}s`, value: 24 },
          ],
          required: true,
        },
        withoutInlineErrorMessage: true,
      };
    },
    billingIntervalErrors() {
      return Object.values(pick(this.errors, ['billing_period', 'billing_interval'])).flat();
    },
    billingLengthErrors() {
      return Object.values(pick(this.errors, ['billing_legth'])).flat();
    },
  },
};
</script>
